"use client";

/* eslint-disable react/prop-types */
import TopNavbar from "@/components/common/viewUserAndAdministration/TopNavbar.jsx";
import BlogManagerSidebar from "./BlogManagerSidebar.jsx";
import BlogManagerBottomNavigation from "./BlogManagerBottomNavigation.jsx";
import BlogManagerRightNavbar from "./BlogManagerRightNavbar.jsx";

const BlogManagerLayout = ({ children }) => {
  return (
    <div className=" min-h-screen">
      <div className=" lg:hidden sm:hidden md:hidden xl:hidden sticky top-0 z-50">
        <TopNavbar
          image={"https://cdn-icons-png.flaticon.com/128/12213/12213586.png"}
          name={"Blog Manager"}
        />
      </div>
      <div className="min-h-screen flex ">
        {/* Sidebar hidden on mobile  */}
        <div className=" w-[16em] flex-none ... hidden sm:block lg:block xl:block md:block ">
          <BlogManagerSidebar />
        </div>

        {/* main content  */}
        <main className="flex-1 min-w-0 mb-[3em] lg:mb-0 ">
          <div className=" sticky top-0 z-50 hidden lg:block md:block sm:block">
            <BlogManagerRightNavbar />
          </div>

          <div className=" px-3 py-3">{children}</div>
        </main>

        <div className=" lg:hidden sm:hidden md:hidden xl:hidden">
          <BlogManagerBottomNavigation />
        </div>
      </div>
    </div>
  );
};

export default BlogManagerLayout;
